"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _polished = require("polished");

var _default = {
  immersiveFlowMobileHeight: (0, _polished.rem)('64px'),
  immersiveFlowHeight: (0, _polished.rem)('80px'),
  immersiveFlowMinDistanceFromTop: (0, _polished.rem)('120px'),
  immersiveFlowMobileMinDistanceFromTop: (0, _polished.rem)('96px'),
  immersiveFlowMinDistanceFromBottom: (0, _polished.rem)('120px'),
  immersiveFlowMobileMinDistanceFromBottom: (0, _polished.rem)('96px')
};
exports.default = _default;
//# sourceMappingURL=immersive-flow.js.map